import { render, staticRenderFns } from "./ConfirmationPage.vue?vue&type=template&id=4e0f0973&scoped=true&"
import script from "./ConfirmationPage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPage.vue?vue&type=style&index=0&id=4e0f0973&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f0973",
  null
  
)

export default component.exports